import { TestSuggestion } from '@/api/generated-catch-backend/model';
import NextArrow from '@/app/components/questionnaireV2/icons/next-arrow';
import icons from '@/assets/icons';
import { PortableText } from '@portabletext/react';

type TestingPlanCardProps = {
  onClick?: () => void;
  test: TestSuggestion;
};

const renderTestIcon = (test: TestSuggestion) => {
  if (test.iconAsset?.url) {
    const altText = test.iconAsset.alt || test.name;
    return <img src={test.iconAsset.url} alt={altText} className="h-auto w-[48px]" />;
  }

  const iconSrc = icons['biomarkers-alt-1'];
  return <img src={iconSrc} alt={test.name} className="h-auto w-[48px]" />;
};

export const TestSuggestionCard = ({ onClick, test }: TestingPlanCardProps) => {
  const isClickable = !!onClick;

  return (
    <button
      className={`relative max-w-[180px] flex-shrink-0 rounded-[10px] border border-[#ededed] bg-white text-left transition-all duration-200 hover:-translate-y-px hover:opacity-80 active:translate-y-0 md:max-w-[240px]`}
      style={{
        cursor: isClickable ? 'pointer' : 'default',
      }}
      disabled={!isClickable}
      aria-disabled={!isClickable}
      onClick={onClick}
      data-testid={`test-suggestion-card-${test.slug}`}
    >
      <div className="flex h-full flex-col p-3 px-[12px] py-[18px]">
        <div className={`arrow-button absolute right-3 max-w-[45px] ${isClickable ? '' : 'hidden'}`}>
          <div className="arrow-icon-container">
            <NextArrow />
          </div>
        </div>
        <div className="align-center flex h-12 items-center">{renderTestIcon(test)}</div>
        <div className="flex flex-col gap-[5px]">
          <div className="mt-1 flex flex-col gap-1">
            <h3 className="text-[16px] leading-[1.5] font-bold text-[#101010]">{test.name}</h3>
            {test.rationaleShort && (
              <div className="text-[14px] leading-[1.4] text-[#606060]">
                <PortableText
                  value={test.rationaleShort}
                  components={{
                    block: {
                      normal: ({ children }) => <p>{children}</p>,
                    },
                    marks: {
                      strong: ({ children }) => <strong>{children}</strong>,
                    },
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};
